import { createContext, useState } from "react";

const ProgressPerformanceContext = createContext({});

export const ProgressPerformanceProvider = ({ children }) => {
  const [tabs, setTabs] = useState(1);

  return (
    <ProgressPerformanceContext.Provider value={{ tabs, setTabs }}>
      {children}
    </ProgressPerformanceContext.Provider>
  );
};

export default ProgressPerformanceContext;
